import { jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class PublicCartDiscountResponse {
  @jsonMember(String)
  public readonly description!: string;

  @jsonMember(Number)
  public readonly discount!: number;
}
